// a global state to save all "resolve"s
export const workerResolver: Record<string, Function> = {};
